// I have extracted this mainly for grep-ability with tooling to demercate this as _the_ place where this gets injected
// so we all now.
//
// Also, lots of things not great about this. We dynamically inject the context required to load the proper ad but since
// this is a combination of injected script via gtm it means we can't have a stable layout block during ssr to slot into
// since we don't know yuntil the client hydrates, which is then always after first paint, which then has the effect of
// janking the whole page layout down 1-2s after render.
//
// My thoughts on injecting ads into our own product thereby knowingly degrading UX can be described using a snippet of
// a famous treatise on such fun matters, below:
//
// Do you like green eggs and ham?
// I do not like them, Sam-I-Am.
// I do not like green eggs and ham.
//
// Would you like them here or there?
// I would not like them here or there.
// I would not like them anywhere.
//
// And one last, while I am here, why was this in the header and not more of a global page thing? I suspect it was due
// to previous iterations of the layout and the corresponding bounding box. I must found out and report back.
//
import React, { ReactNode } from 'react'
import { FeatureFlags, NullComponent, useApplicationContext } from '@adc/ui-adc'

const AdvertisementInjection = ({
  dataAdSpace,
  className,
  children,
}: {
  dataAdSpace: string
  className?: string
  children?: ReactNode
}) => {
  const { featureFlags } = useApplicationContext()
  if (!featureFlags as FeatureFlags['fe.resi.enable-ad-injection']) {
    return <NullComponent />
  }

  return (
    <>
      <div data-ad-space={dataAdSpace} className={className}>
        {children}
      </div>
    </>
  )
}

export default AdvertisementInjection
